// extracted by mini-css-extract-plugin
export default {"navigateWeeks":"navigate-weeks_navigateWeeks__+18vS"};